<template>
  <!-- Top Navbar -->
  <section>
    <nav class="navbar navbar-expand-lg navbar-light bg-white">
      <router-link
        class="navbar-brand"
        :to="getRouteSelect"
        v-slot="{ href, navigate }"
      >
        <a :href="href" @click="navigate">
          <img :src="getLogoSelect" />
        </a>
      </router-link>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto" v-if="listMenu.length > 0">
          <li
            v-for="menu in listMenu"
            :key="menu.idMenu"
            class="nav-item dropdown"
          >
            <router-link
              v-if="menu.children.length === 0"
              class="nav-link f-default"
              :to="menu.url"
              v-slot="{ href, navigate }"
            >
              <a :href="href" @click="navigate">
                {{ menu.label }}
              </a>
            </router-link>
            <a
              href="#"
              class="nav-link f-default"
              id="dropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              :class="
                menu.children && menu.children.length > 0
                  ? 'dropdown-toggle'
                  : ''
              "
              v-else
              >{{ menu.label }}</a
            >
            <div
              class="dropdown-menu"
              aria-labelledby="dropdown"
              v-if="menu.children.length > 0"
            >
              <router-link
                class="dropdown-item"
                :to="child.url"
                v-for="child in menu.children"
                :key="child.idMenu"
                custom
              v-slot="{ href, navigate }"
              >
                <a :href="href" @click="navigate">
                  {{ child.label }}
                </a>
              </router-link>
            </div>
          </li>
        </ul>

        <div class="navbar-nav mr-auto" v-else>
          <pulse-loader color="#343a40" />
        </div>

        <ul class="navbar-nav hk-navbar-content">
          <li class="nav-item dropdown dropdown-authentication">
            <a
              class="nav-link dropdown-toggle no-caret"
              href="#"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div class="media">
                <div class="media-body f-default">
                  <span
                    >{{ username
                    }}<i class="ml-1 mr-2 bi bi-caret-down-fill"></i
                  ></span>
                </div>
              </div>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right"
              data-dropdown-in="flipInX"
              data-dropdown-out="flipOutX"
            >
              <router-link
                to="/user-profile"
                v-slot="{ href, navigate }"
                class="dropdown-item"
              >
                <a :href="href" @click="navigate">
                  <i class="bi bi-person-square pr-2"></i><span>Perfil</span>
                </a>
              </router-link>

              <div class="dropdown-divider"></div>
              <a class="dropdown-item" @click="logout"
                ><i class="bi bi-box-arrow-right pr-2"></i
                ><span>Log out</span></a
              >
            </div>
          </li>
        </ul>
        <!-- <div class="apps--button" @click="isOpen = !isOpen">
          <img src="@/assets/img/svgs/apps.svg" alt="" />
        </div> -->
      </div>
    </nav>
    <!-- <div class="apps-nav" :class="{ 'apps-nav--open': isOpen }">
      <b-container class="h-100">
        <b-row class="h-100 d-flex align-items-center">
          <b-col cols="12" md="5" class="d-flex justify-content-center">
            <router-link to="/odin" v-slot="{ href, navigate }">
              <a
                :href="href"
                @click="
                  navigate
                  isOpen = !isOpen
                "
                :class="{ disabled: !$store.getters['auth/isOdin'] }"
              >
                <img class="" src="@/assets/img/logos/odin.svg" />
              </a>
            </router-link>
          </b-col>
          <b-col cols="2" class="d-flex justify-content-center">
            <div class="pipe"></div>
          </b-col>
          <b-col cols="12" md="5" class="d-flex justify-content-center">
            <router-link to="/loki" v-slot="{ href, navigate }">
              <a
                :href="href"
                @click="
                  navigate
                  isOpen = !isOpen
                "
                :class="{ disabled: !$store.getters['auth/isLoki'] }"
              >
                <img class="" src="@/assets/img/logos/loki.svg" />
              </a>
            </router-link>
          </b-col>
        </b-row>
      </b-container>
    </div> -->
  </section>
</template>

<script>
import { mixins } from '@/mixins/mixins'
import PulseLoader from 'vue-spinner/src/PulseLoader'

export default {
  components: {
    PulseLoader,
  },
  mixins: [mixins],

  watch: {
    isMenu() {
      const menu = this.isMenu.map(parent => {
        const children = parent.children.sort( (a, b) => {
          if (a.label > b.label) return 1
          if (a.label < b.label) return -1
          return 0
        })
        return {
          ...parent,
          children
        }
      })
      this.listMenu = [
        menu[0],
        menu[1],
        menu[2],
        menu[4],
        menu[3]
      ].filter(x => x !== undefined)
    },
  },
  data() {
    return {
      listMenu: [],
      isOpen: false,
    }
  },
  methods: {
    logout() {
      this.$store.commit('auth/logout')
      this.$router.push('/login')
    },
  },
  computed: {
    username() {
      return this.$store.getters['auth/name']
    },
    isMenu() {
      return this.$store.getters['utils/isMenu']
    },

    getLogoSelect() {
      const route = this.$route.fullPath
      const apps = {
        odin: require('@/assets/img/logos/odin.svg'),
        loki: require('@/assets/img/logos/loki.svg'),
      }
      if (route === '/user-profile') {
        return require('@/assets/img/logos/odin.svg')
      }

      return apps[route.split('/')[1]]
    },
    getRouteSelect() {
      const route = this.$route.fullPath
      const apps = {
        odin: '/odin',
        loki: '/loki',
      }
      if (route === '/user-profile') {
        return '/'
      }
      return apps[route.split('/')[1]] ?? '/'
    },
  },
}
</script>

<style scoped lang="scss">
.pipe {
  background-color: #c3c3c3;
  height: 35px;
  width: 2px;
}
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.apps {
  &--button {
    cursor: pointer;
  }
  &-nav {
    transition: 0.3s all ease-in-out;
    width: 100%;
    height: 66px;
    background-color: #f5f5f6;
    position: absolute;
    top: 0px;
    z-index: 2;
    &--open {
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);
      margin-top: 66px;
    }
  }
}

.navbar {
  box-shadow: 0 0 28px #00000012;
  z-index: 133;
}
</style>
